export default __webpack_public_path__ + "static/media/1of1.176467a6.png";